import "./slider";
import "./contact";
import "./panel-list-left-justify-flex";
import "./remove-last-line-margin";



const header = document.querySelector("header");
const headerBtn = document.querySelector('.sp-header__btn');
const headerContent = document.querySelector('.sp-header__content')
const headerContentBg = document.querySelector('.sp-header__content-bg')
const headerContentClose = document.querySelector('.sp-header__content-close')
const headerUnderlayer = document.querySelector('.header-underlayer')
const body = document.getElementsByTagName('body')

function toggleHeader() {
    headerContent.classList.toggle('sp-header__content--active');
    body[0].classList.toggle('fixed');
}
function scrollHeader() {
    if (window.scrollY > 0) {
        header.classList.add("header--scroll");
    } else {
        header.classList.remove("header--scroll");
    }
}

if (header) {
    headerBtn.addEventListener("click", toggleHeader);
    headerContentBg.addEventListener("click", toggleHeader);
    headerContentClose.addEventListener("click", toggleHeader);

    if (!headerUnderlayer) {
        window.addEventListener("scroll",scrollHeader);
        window.addEventListener("DOMContentLoaded",scrollHeader);
    } else {
        window.addEventListener("DOMContentLoaded", () => {
            header.classList.add("header--scroll");
        });
    }
}



// WYSIWYGで出力した3階層目のUL要素にクラスを追加（markerをアルファベットにする処理）
window.addEventListener("DOMContentLoaded", () => {
    const containerList = document.querySelectorAll(".container__list");
    if (containerList) {
        containerList.forEach((list) => {
            const listItems = list.querySelectorAll("li");
                listItems.forEach((item) => {
                const itemLists = item.querySelectorAll(".container__list");
                if (itemLists) {
                    itemLists.forEach((list) => {
                        const listItems = list.querySelectorAll("li");
                        if (listItems) {
                            listItems.forEach((item) => {
                                const itemLists = item.querySelectorAll(".container__list");
                                if (itemLists) {
                                    itemLists.forEach((list) => {
                                        list.classList.add("container__list--alpha");
                                    });
                                }
                            });
                        }
                    });
                }
            }
            );
        });
    }
}
);